import { useLang } from '../LangContext';

const imgs = [
  'https://images.unsplash.com/photo-1575783970733-1aaedde1db74?w=400&q=80', // soft play - kids playing in colorful play area
  'https://images.unsplash.com/photo-1551966775-a4ddc8df052b?w=400&q=80', // obstacle course - kids running outdoor
  'https://images.unsplash.com/photo-1566140967404-b8b3932483f5?w=400&q=80', // ball pit - kids in colorful balls
  'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&q=80', // puzzles & letters - kids studying with books
  'https://images.unsplash.com/photo-1491013516836-7db643ee125a?w=400&q=80', // basic manners - kids sharing/together nicely
  'https://images.unsplash.com/photo-1472162072942-cd5147eb3902?w=400&q=80', // learning through fun - kids laughing in class
];

export default function Programs() {
  const { t } = useLang();

  return (
    <section id="programs" className="programs">
      <span className="section-tag center">{t.programsTag}</span>
      <h2 className="section-title">{t.programsTitle}</h2>
      <p className="section-subtitle">{t.programsSub}</p>
      <div className="programs-grid">
        {t.programs.map((p, i) => (
          <div className="program-card" key={i}>
            <img src={imgs[i]} alt={p.title} />
            <div className="program-body">
              <div className="program-icon">{p.icon}</div>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
